const baseUrl = 'https://wxapp.chinardr.net/'
// const baseUrl = 'http://192.168.1.114:7001/'

// const baseUrl = 'http://192.168.1.103:7001/'
// const baseUrl = 'http://192.168.1.114:7001/'
// const baseUrl = 'http://192.168.1.103:7001/'

export default baseUrl